import React from "react";
import GridItemProps from "./props";
import "./style.scss";

const GridItem = ({ children, index }: GridItemProps) => {
  return (
    <div className="grid-item" data-e2e={`grid-item-${index}`}>
      {children}
    </div>
  );
};

export default GridItem;